import * as Sentry from '@sentry/browser';

Sentry.init({
  dsn:
    'https://b20c8dfae59c4c04ac73e2a4f83fb081@o142675.ingest.sentry.io/4504249203556352',
  release: process.env.SHA,
  environment: process.env.SENTRY_ENVIRONMENT || 'staging',
  beforeSend(event) {
    addUserData(event);
    filterEmptyUnhadledRejections(event);
    return event;
  },
});

function addUserData(event) {
  if (!window.champaign) return;
  if (!window.champaign.personalization) return;
  const { location, member } = window.champaign.personalization;
  Sentry.setUser({
    id: member ? member.id : undefined,
    username: member ? member.name : undefined,
    ip: location ? location.ip : undefined,
  });
}

function filterEmptyUnhadledRejections(event) {
  // filter out UnhandledRejection errors that have no information
  if (
    event !== undefined &&
    event.exception !== undefined &&
    event.exception.values !== undefined &&
    event.exception.values.length == 1
  ) {
    var e = event.exception.values[0];
    if (
      e.type === 'UnhandledRejection' &&
      e.value.indexOf(
        'Non-Error promise rejection captured with value: Object Not Found Matching Id:'
      ) > -1
    ) {
      return null;
    }
  }
}

window.Sentry = Sentry;
